import { SAVE_PLANS, PLAN_SELECT } from '../constants/actionTypes';

const doSavePlans = data => ({
  type: SAVE_PLANS,
  payload: data,
});

const doSelectPlan = plan => ({
  type: PLAN_SELECT,
  payload: plan,
});

export { doSavePlans, doSelectPlan };
